var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DateTimePicker',_vm._b({attrs:{"value":_vm.date,"type":"time","hide-label":true},on:{"input":_vm.change}},'DateTimePicker',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }